import { CheckboxGroupField, CheckboxGroupFieldProps, CheckboxOption } from 'components/form/field/CheckboxGroupField'
import { RecursoIntegracaoEnum } from 'graphql/types.generated'
import React from 'react'

import { recursosIntegracao } from './model-credencial-integracao'

type RecursosCredencialIntegracaoGroupBoxFieldProps = Omit<CheckboxGroupFieldProps<RecursoIntegracaoEnum[]>, 'options'>

export default function RecursosCredencialIntegracaoGroupBoxField(
  props: RecursosCredencialIntegracaoGroupBoxFieldProps
) {
  return <CheckboxGroupField options={options} {...props} vSpacing={1} />
}

const options: CheckboxOption<RecursoIntegracaoEnum>[] = recursosIntegracao.map((recurso) => ({
  label: recurso.description,
  value: recurso.enum,
}))
